import React, { useCallback, useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { BiData } from '@wix/da-bi/pkg/events';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import IconButtonWithContextMenu from '@wix/da-ds/pkg/Dropdown/Preset/IconButtonWithContextMenu';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import Headerless from '@wix/da-ds/pkg/modals/dsPresets/HeaderlessModal/HeaderlessModal';
import { MuroDepContext } from '@wix/da-react-context/pkg/MuroDepContext';
const MoreMenu = ({ isLoggedIn, className, menuClassName })=>{
    const { t } = useTranslation();
    const isMuro = useFlag('mini_muro');
    const [showMuro, setShowMuro] = useState(false);
    const { MiniComponent } = useContext(MuroDepContext);
    const handleClose = useCallback(()=>{
        setShowMuro(false);
    }, [
        setShowMuro
    ]);
    const items = useMemo(()=>[
            {
                items: [
                    {
                        key: 'dreamup',
                        label: t('siteHeader.dreamup'),
                        link: Url.dreamupLink(),
                        newTag: 'purple',
                        target: isLoggedIn ? undefined : '_blank',
                        biData: BiData({
                            evid: 700,
                            link_name: 'dreamup',
                            link_url: Url.dreamupLink()
                        })
                    },
                    {
                        key: 'create-group',
                        label: t('siteHeader.createGroup'),
                        link: Url.to(URLS.GROUPS_CREATE),
                        biData: BiData({
                            evid: 700,
                            link_name: 'create-group',
                            link_url: Url.to(URLS.GROUPS_CREATE)
                        })
                    },
                    {
                        key: 'monetize',
                        label: t('siteHeader.monetize'),
                        link: URLS.SHOP_TOP_NAV,
                        target: '_blank',
                        biData: BiData({
                            evid: 700,
                            link_name: 'deviantartsell',
                            link_url: URLS.SHOP_TOP_NAV
                        })
                    }
                ]
            },
            {
                items: [
                    {
                        key: 'forum',
                        label: t('siteHeader.forum'),
                        link: Url.buildFromPath(URLS.FORUM),
                        biData: BiData({
                            evid: 700,
                            link_name: 'forum',
                            link_url: Url.buildFromPath(URLS.FORUM)
                        })
                    },
                    {
                        key: 'betaTesting',
                        label: t('siteHeader.betaTesting'),
                        link: URLS.BETA_TESTING,
                        target: '_blank',
                        biData: BiData({
                            evid: 700,
                            link_name: 'betaTesting',
                            link_url: URLS.BETA_TESTING
                        })
                    },
                    {
                        key: 'whatsNew',
                        label: t('siteHeader.whatsNew'),
                        link: Url.to(URLS.TEAM),
                        target: '_blank',
                        biData: BiData({
                            evid: 700,
                            link_name: 'whatsNew',
                            link_url: Url.to(URLS.TEAM)
                        })
                    },
                    {
                        key: 'communityEvents',
                        label: t('siteHeader.communityEvents'),
                        link: 'https://www.deviantart.com/moonbeam13/journal/Community-Events-1155532870',
                        target: '_blank',
                        biData: BiData({
                            evid: 700,
                            link_name: 'communityEvents',
                            link_url: Url.to(URLS.TEAM)
                        })
                    },
                    isMuro && {
                        key: 'muro',
                        label: 'DeviantArt Draw',
                        newTag: 'purple',
                        target: isLoggedIn ? undefined : '_blank',
                        onClick: ()=>{
                            setShowMuro(true);
                        }
                    }
                ]
            }
        ], [
        t,
        isLoggedIn,
        isMuro
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "MoreMenu"
    }, /*#__PURE__*/ React.createElement(IconButtonWithContextMenu, {
        className: className,
        standardMenuProps: {
            className: menuClassName
        },
        popperManagerProps: {
            isInPopup: true
        },
        placement: "bottom-end",
        openOnHover: true,
        items: items,
        size: "large",
        variant: "main",
        icon: EllipsisIcon,
        "aria-label": t('siteHeader.more')
    })), showMuro && MiniComponent && /*#__PURE__*/ React.createElement(Headerless, {
        useFixedMobileHeight: true,
        isOpen: true,
        hasCloseButton: true,
        onRequestClose: handleClose
    }, /*#__PURE__*/ React.createElement(MiniComponent, {
        canvasSize: 1152,
        aspectRatio: '4:3'
    })));
};
MoreMenu.displayName = 'MoreMenu';
export default MoreMenu;

//# sourceMappingURL=MoreMenu.js.map